<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('analysesStatusManagement.title') }}</h2>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'AnalysesStatusManagement',
  };
</script>
